import { Inject, Injectable, Injector } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { USER_REPOSITORY_TOKEN } from "@karma-games/angular-devkit/src/lib/modules/user";
import { IClientUserRepository } from "../interfaces";

@Injectable()
export class AttachBalanceListenerUseCase implements IUseCase<Injector, void> {
    constructor(@Inject(USER_REPOSITORY_TOKEN) private userRepository: IClientUserRepository) {
    }

    execute(injector: Injector): void {
        this.userRepository.attachBalanceListener(injector);
    }
}
